// extracted by mini-css-extract-plugin
export default {"wrapper":"BuildingAddress_wrapper__er8ve","copy_icon":"BuildingAddress_copy_icon__pc16k"};